import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function defaultQuestionsValidator(): ValidatorFn {
  return ({ value: { patientStars, doctorReputation } }: AbstractControl): ValidationErrors | null => {
    const isProvided = (value: unknown): boolean => value !== null && value !== undefined && value !== '';

    const groupedAnswers = [patientStars, doctorReputation];
    const allGroupedProvided = groupedAnswers.every(isProvided);

    if (!allGroupedProvided) return { defaultQuestionsInvalid: true };
    return null;
  };
}
